import { render, staticRenderFns } from "./TradeHub.vue?vue&type=template&id=7bf9610c&scoped=true"
import script from "./TradeHub.vue?vue&type=script&lang=js"
export * from "./TradeHub.vue?vue&type=script&lang=js"
import style0 from "./TradeHub.vue?vue&type=style&index=0&id=7bf9610c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf9610c",
  null
  
)

export default component.exports